import React, { useState } from 'react';
import ModalMarketingForm from 'components/Form/ModalMarketingForm';

import { StyledButton } from './DesktopMenu/RightMenu/styles';

const HeaderModalForm = ({ buttonLabel, inlineMarketingForm, type, className }) => {
  const [isModalOpen, toggleIsModalOpen] = useState(false);

  return (
    <>
      <StyledButton
        className={className}
        title={buttonLabel}
        dataPosition="header cta"
        ctaPosition="navigation"
        onClick={() => toggleIsModalOpen(true)}
        type={type}
      >
        {buttonLabel}
      </StyledButton>
      <ModalMarketingForm
        dataPosition="Header"
        isModalOpen={isModalOpen}
        inlineMarketingForm={inlineMarketingForm}
        onModalCancel={() => toggleIsModalOpen(false)}
        onFormSuccess={() => toggleIsModalOpen(false)}
      />
    </>
  );
};

export default HeaderModalForm;
